// src/api_scripts/getskilldefinitionsList.js
import { fetchAllPages } from "../paginationUtils";

const getskilldefinitionsList = async (skilldefinitionsListName, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/skill`;

  try {
    const dataArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Skill Definitions");
    console.log("Get Skill Definitions API Response Data (all pages):", dataArray.length, "items");
    return dataArray;

  } catch (error) {
    console.error(`Error fetching Skill Definitions:`, error);
    throw error;
  }
};

export default getskilldefinitionsList;